import * as api from '../api';
import * as flights from '../flights';

export class OrderModel {
    reservationInfo: api.ReservationInfo;
    flight: flights.FlightModel;

    constructor(reservation: api.ReservationStatusResult) {
        this.reservationInfo = reservation.reservationInfo;
        this.flight = new flights.FlightModel(reservation.flight, reservation);
    }
}
